import Base from 'app/collections/base';
import { fulfillmentUrl } from 'utils/wrappers';
import FulfillmentOrder from 'app/models/fulfillment_order';

export default Base.extend({
  model: FulfillmentOrder,
  url: fulfillmentUrl('orders'),

  initialize(models, options) {
    this.dateRange = options.dateRange;
    this.apiMode = options.apiMode;
    this.listenTo(this.dateRange, 'change', this.reportFiltered);
    this.listenTo(this.apiMode, 'change:mode', this.reportFiltered);
  },

  reportFiltered() {
    this.trigger('filtered');
  },

  searchById(term) {
    if (!term || !term.trim()) {
      this.reset();
      this.trigger('sync');
      return;
    }

    // call fulfillment api, based on prefix to get by either warehouse id or
    const filterType = term.trim().split('_', 1)[0];
    const self = this;

    if (filterType === 'order') {
      new this.model({ id: term }).fetch({
        data: {
          mode: this.apiMode.get('mode'),
        },
        success(model) {
          self.reset([model]);
        },
        error() {
          self.reset();
          self.trigger('sync');
        },
      });

      return;
    }

    // assume tracking code
    this.fetch({ data: { tracking_code: term }});
  },

  paramsForFetch() {
    return {
      mode: this.apiMode.get('mode'),
      start_datetime: this.dateRange.getStartDatetimeForParamIso(),
      end_datetime: this.dateRange.getDayAfterEndDatetimeForParamIso(),
    };
  },

  parse(response) {
    this.hasMore = response.orders.length === 10;
    return response.orders;
  },
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_orders.js